// @flow

import { type IncomingPayment, getHash } from '@tectonics/prs/incoming-payment';
import { type UserInputValues } from '@tectonics/prs/user-input-values';
import { type OutgoingPayment } from '@tectonics/prs/outgoing-payment';
import { fingerprint } from '@tectonics/prs/fingerprint';

export async function fingerprintOutgoingPaymentMapper(
  userInputValues: UserInputValues,
  incomingPayment: IncomingPayment,
): Promise<$Shape<OutgoingPayment>> {

  const deviceID = await fingerprint(incomingPayment);

  return {
    hash: getHash(incomingPayment),
    device_id: deviceID,
  };

}
